import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Link,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { useRouter } from 'next/router';
import { useState } from 'react';

import CustomButton from '../ui/CustomButton';

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const ExemptSubMenu = () => {
  const router = useRouter();
  const resourcesRouteStartUrl = '/resources/';
  const [selectedSubMenu, setSelectedSubMenu] = useState('');

  function getActiveClassName(currentPath: string[]) {
    const pathName = router.pathname;
    if (pathName === '/' && currentPath.includes('/')) {
      return 'Mui-second-level-selected-menu';
    }
    const matchingPaths = currentPath.filter((p) => pathName.startsWith(p));
    if (matchingPaths.length > 0 && !currentPath.includes('/'))
      return 'Mui-second-level-selected-menu';
    return '';
  }

  // handle click for Sub Menu in Mobile view
  function getSubMenuHoverClassName(currentSubMenu: string) {
    if (
      currentSubMenu !== undefined &&
      currentSubMenu !== '' &&
      selectedSubMenu !== undefined &&
      selectedSubMenu !== '' &&
      selectedSubMenu === currentSubMenu
    ) {
      return 'dropdown-menu button-hover';
    }
    return 'dropdown-menu';
  }

  function toggleSelectedSubMenu(currentSubMenu: string) {
    if (selectedSubMenu !== undefined && selectedSubMenu !== '') {
      if (currentSubMenu !== selectedSubMenu) {
        setSelectedSubMenu(currentSubMenu);
      } else {
        setSelectedSubMenu('');
      }
    } else {
      setSelectedSubMenu(currentSubMenu);
    }
  }
  return (
    <Box
      sx={{
        backgroundColor: 'rgba(235, 235, 235, 0.85)',
        backdropFilter: 'saturate(50%) blur(5px)',
        borderBottom: '1px solid #dcdcdc',
        py: 1,
        px: 3,
        color: '#14181f',
        textAlign: 'right',
        position: 'sticky',
        left: 0,
        right: 0,
        top: 64,
        zIndex: 999,
        minHeight: { sm: 50, md: 54 },
        display: { xs: 'none', sm: 'flex' },
        justifyContent: 'flex-end',
        '& a:hover': { backgroundColor: 'transparent' },
      }}
      component="nav"
      aria-label="Secondary Navigation"
    >
      <Container
        maxWidth="lg"
        sx={{
          p: '0 !important',
          display: 'flex',
          '& .Mui-second-level-selected-menu::before': { bottom: -10 },
        }}
      >
        <CustomButton
          href="/tax-exempt/"
          text="Exempt Org. <br /> Forms"
          custom="margin-right:0px; line-height:1.2; padding-top:0px; padding-bottom:0px; text-align:left;"
          icon={
            <Box
              component="img"
              src="/assets/images/nonprofit-icon.png"
              alt="Exempt Organizations Forms"
              sx={{ width: { sm: 32, md: 36 }, height: { sm: 32, md: 36 } }}
            />
          }
          // className={getActiveClassName(['/tax-exempt'])}
          sm="12px"
          md="14px"
        />
        <Box sx={{ flexGrow: 1 }} />
        <Box
          className={getSubMenuHoverClassName('btn-exempt-supported-forms')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            aria-haspopup="true"
            id="btn-exempt-supported-forms"
            onClick={() => toggleSelectedSubMenu('btn-exempt-supported-forms')}
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
            className={getActiveClassName([
              '/tax-exempt/e-file-irs-form-990-ez',
              '/tax-exempt/e-file-irs-form-990',
              '/tax-exempt/e-file-irs-form-990-pf',
              '/tax-exempt/e-file-irs-form-990-t',
              '/tax-exempt/e-file-irs-form-5227',
              '/tax-exempt/e-file-irs-form-990-schedules',
              '/tax-exempt/efile-ftb-ca-form199-online',
              '/tax-exempt/e-file-form-990-amendments',
              '/tax-exempt/e-file-nonprofit-return-with-ein',
              '/tax-exempt/e-file-irs-form-1120-pol',
              '/tax-exempt/efile-ftb-ca-form109-online',
            ])}
          >
            Supported Forms
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{ width: 250, '&:before': { left: 50 } }}
          >
            <Box component="ul">
              <li>
                <Link
                  href={`${process.env.NEXT_PUBLIC_990N_SITE_URL}?ref=exempt`}
                >
                  Form 990-N (e-Postcard){' '}
                </Link>
              </li>
              <li>
                <Link href="/tax-exempt/e-file-irs-form-990-ez/">
                  Form 990-EZ
                </Link>
              </li>
              <li>
                <Link href="/tax-exempt/e-file-irs-form-990/">Form 990</Link>
              </li>
              <li>
                <Link href="/tax-exempt/e-file-irs-form-990-pf/">
                  Form 990-PF
                </Link>
              </li>
              <li>
                <Link href="/tax-exempt/e-file-irs-form-990-t/">
                  Form 990-T
                </Link>
              </li>
              <li>
                <Link href="/tax-exempt/e-file-irs-form-5227/">Form 5227</Link>
              </li>
              <li>
                <Link href="/tax-exempt/efile-ftb-ca-form199-online/">
                  CA FTB - Form 199
                </Link>
              </li>
              <li>
                <Link href="/tax-exempt/efile-ftb-ca-form109-online/">
                  CA FTB - Form 109
                </Link>
              </li>
              <li>
                <Link href="/tax-extension/efile-irs-form-8868-exempt-organization-tax-extension-online/">
                  990 Extension{' '}
                  <span style={{ fontWeight: 700 }}> (Form 8868)</span>
                </Link>
              </li>
              <li>
                <Link href="/tax-exempt/e-file-irs-form-990-schedules/">
                  Form 990 Schedules
                </Link>
              </li>

              <li>
                <Link href="/tax-exempt/e-file-form-990-amendments/">
                  990 Amendment Returns
                </Link>
              </li>
              <li>
                <Link href="/tax-exempt/e-file-irs-form-1120-pol/">
                  Form 1120-POL
                </Link>
              </li>
            </Box>
          </Box>
        </Box>
        <Box
          className={getSubMenuHoverClassName('btn-exempt-resources')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-exempt-resources"
            onClick={() => toggleSelectedSubMenu('btn-exempt-resources')}
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
          >
            Resources
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: 250,
              right: 'auto !important',
              left: 0,
              '&:before': { left: 50 },
            }}
          >
            <Box component="ul">
              <li>
                <Link href="/resources/tax-exempt/form-990-n-instructions/">
                  Form 990-N Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/form-990-ez-instructions/">
                  Form 990-EZ Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/form-990-instructions/">
                  Form 990 Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/form-990-due-dates/">
                  990 Forms Series Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/form-990-penalties/">
                  Forms 990 Penalties
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/form-990-mailing-address/">
                  Form 990 Mailing Address
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/form-990-vs-form-990-ez/">
                  Form 990 vs Form 990-EZ
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/form-990-n-vs-form-990-ez/">
                  Form 990-N vs Form 990-EZ
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/automatic-revocation-of-tax-exempt-status/">
                  Automatic Revocation
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/form-1023/">Form 1023</Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/form-990-pf-instructions/">
                  Form 990-PF Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/form-990-t-instructions/">
                  Form 990-T Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/form-990-t-schedule-a/">
                  Form 990-T Schedule A
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/form-5227-instructions/">
                  Form 5227 Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/form-5227-filing-due-dates/">
                  Form 5227 Due Dates
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/form-5227-penalties/">
                  Form 5227 Penalties
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/form-5227-schedule-e/">
                  Form 5227 Schedule E (1040)
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/form-8582-instructions/">
                  Form 8582 Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/form-1120-pol-instructions/">
                  Form 1120-POL Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/form-109-instructions/">
                  CA Form 109 Instructions
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/transfer-election-statement/">
                  Transfer Election Statement
                </Link>
              </li>
              <li>
                <Link href="/resources/tax-exempt/ca-form-rrf1-filing-guide/">
                  Form RRF-1
                </Link>
              </li>
              <li>
                <Link
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/tax-exempt/ftb-ca-form-199-filing/`}
                >
                  FTB CA Form 199 Instructions
                </Link>
              </li>
            </Box>
          </Box>
        </Box>
        <Box
          className={getSubMenuHoverClassName('btn-exempt-schedules')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-exempt-schedules"
            onClick={() => toggleSelectedSubMenu('btn-exempt-schedules')}
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
          >
            Forms &amp; Schedules
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: { sm: 730, md: 730, lg: 730 },
              pt: '0 !important',
              left: {
                lg: '-504px !important',
                md: '-521px !important',
                sm: '-506px !important',
              },
              '&:before': { left: { lg: 590, md: 606, sm: 585 } },
            }}
          >
            <Box sx={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }}>
              <Grid
                container
                spacing={2}
                m={0}
                className="MuiGrid-root-width"
                sx={{ justifyContent: 'center', px: 2 }}
              >
                <Grid size={{ xs: 12, sm: 5.8 }}>
                  <Paper
                    variant="outlined"
                    sx={{
                      border: '0px solid #dedede',
                      borderRadius: 2,
                      mb: 0,
                      '& a': {
                        pl: '10px !important',
                        borderColor: '#dedede',
                        borderRadius: 2,
                      },
                      '& a:hover': {
                        color: '#c02652 !important',
                        backgroundColor: '#dedfe1',
                        borderColor: '#637381',
                      },
                      '& a button': { transition: 'all 0.3s ease' },
                      '& a:hover button': { transform: 'translateX(5px)' },
                      '& > a': {
                        p: '10px !important',
                        mr: 0,
                        mb: { lg: 0, xl: 0 },
                        border: '1px solid #dedede',
                        borderRadius: 3,
                        minHeight: { lg: 87, xl: 86 },
                      },
                      '& > a:hover': {
                        color: '#213e99 !important',
                        backgroundColor: '#dedfe1',
                        borderColor: '#637381',
                      },
                      '& > a:hover h6': {
                        color: '#c02652 !important',
                      },
                      '& > a:hover .form-icon': { backgroundColor: '#fff' },
                    }}
                  >
                    <Link
                      href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/`}
                      sx={{}}
                    >
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={1}
                        sx={{
                          mr: 0,
                          justifyContent: 'flex-start',
                          alignItems: 'flex-start',
                        }}
                      >
                        {/* <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <Box
                          sx={{
                            backgroundColor: 'none',
                            borderRadius: 50,
                            textAlign: 'center',
                            minWidth: { xs: 'inherit', sm: 36 },
                            minHeight: { xs: 'inherit', sm: 36 },
                            alignItems: 'center',
                            justifyContent: 'center',
                            display: 'flex',
                            p: { xs: 0.5, sm: 1 },
                            transition: 'all 0.3s ease 0s',
                          }}
                          className="form-icon"
                        >
                          <img
                            src="/assets/images/nonprofit-icon.png"
                            alt="Exempt Organizations Forms"
                            width={48}
                            height={48}
                          />
                        </Box>
                      </Box> */}
                        <Box sx={{ flexGrow: 1 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontSize: { xs: 18, md: 16, lg: 15, xl: 16 },
                              fontWeight: 600,
                              color: '#374151',
                            }}
                          >
                            Form 990 <span style={{ fontWeight: 300 }}>|</span>{' '}
                            990-EZ <span style={{ fontWeight: 300 }}>|</span>{' '}
                            990-PF
                          </Typography>

                          <Typography
                            variant="body2"
                            sx={{ color: '#637381', fontSize: 13 }}
                          >
                            These schedules will be auto-generated while you
                            file your 990 form with us.{' '}
                          </Typography>
                        </Box>
                        <IconButton
                          sx={{
                            alignSelf: 'center',
                            p: 0.5,
                          }}
                        >
                          <ArrowForwardIosOutlinedIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </Stack>
                    </Link>
                  </Paper>
                  <Grid
                    container
                    spacing={2}
                    m={0}
                    sx={{
                      pt: '0 !important',
                      '& a': {
                        pl: '10px !important',
                        borderColor: '#dedede',
                        borderRadius: 2,
                      },
                      '& a:hover': {
                        color: '#c02652 !important',
                        backgroundColor: '#dedfe1',
                        borderColor: '#637381',
                      },
                    }}
                  >
                    <Grid
                      size={{ xs: 12, sm: 6 }}
                      sx={{
                        pt: '8px !important',
                      }}
                    >
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-990-schedule-a/`}
                      >
                        Schedule A
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-990-schedule-b/`}
                        // className={getSubMenuActiveClassName(
                        //   '/information-returns/efile-irs-form-w2'
                        // )}
                      >
                        Schedule B
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-990-schedule-c/`}
                      >
                        Schedule C
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-990-schedule-d/`}
                      >
                        Schedule D
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-990-schedule-e/`}
                      >
                        Schedule E
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-990-schedule-f/`}
                      >
                        Schedule F
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-990-schedule-g/`}
                      >
                        Schedule G
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-990-schedule-i/`}
                      >
                        Schedule I
                      </Button>
                    </Grid>
                    <Grid
                      size={{ xs: 12, sm: 6 }}
                      sx={{
                        pt: '8px !important',
                      }}
                    >
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-990-schedule-j/`}
                      >
                        Schedule J
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-990-schedule-k/`}
                      >
                        Schedule K
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-990-schedule-l/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Schedule L
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-990-schedule-m/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Schedule M
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-990-schedule-n/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Schedule N
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-990-schedule-o/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Schedule O
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-990-schedule-r/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Schedule R
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 0.1, md: 0.1 }}
                  sx={{ mt: 2, mb: 1, borderRight: '1px solid #dedede' }}
                />
                <Grid size={{ xs: 12, sm: 5.8 }}>
                  <Paper
                    variant="outlined"
                    sx={{
                      border: '0px solid #dedede',
                      borderRadius: 2,
                      mb: 0,
                      '& a': {
                        pl: '10px !important',
                        borderColor: '#dedede',
                        borderRadius: 2,
                      },
                      '& a:hover': {
                        color: '#c02652 !important',
                        backgroundColor: '#dedfe1',
                        borderColor: '#637381',
                      },
                      '& a button': { transition: 'all 0.3s ease' },
                      '& a:hover button': { transform: 'translateX(5px)' },
                      '& > a': {
                        p: '10px !important',
                        mr: 0,
                        mb: { lg: 0, xl: 0 },
                        border: '1px solid #dedede',
                        borderRadius: 3,
                        minHeight: { lg: 87, xl: 86 },
                      },
                      '& > a:hover': {
                        color: '#213e99 !important',
                        backgroundColor: '#dedfe1',
                        borderColor: '#637381',
                      },
                      '& > a:hover h6': {
                        color: '#c02652 !important',
                      },
                      '& > a:hover .form-icon': { backgroundColor: '#fff' },
                    }}
                  >
                    <Link
                      href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}tax-exempt/e-file-irs-form-990-t/`}
                      sx={{}}
                    >
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={1}
                        sx={{
                          mr: 0,
                          justifyContent: 'flex-start',
                          alignItems: 'flex-start',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          {/* <Box
                          sx={{
                            backgroundColor: 'none',
                            borderRadius: 50,
                            textAlign: 'center',
                            minWidth: { xs: 'inherit', sm: 36 },
                            minHeight: { xs: 'inherit', sm: 36 },
                            alignItems: 'center',
                            justifyContent: 'center',
                            display: 'flex',
                            p: { xs: 0.5, sm: 1 },
                            transition: 'all 0.3s ease 0s',
                          }}
                          className="form-icon"
                        >
                          <img
                            src="/assets/images/nonprofit-icon.png"
                            alt="Exempt Organizations Forms"
                            width={48}
                            height={48}
                          />
                        </Box> */}
                        </Box>
                        <Box sx={{ flexGrow: 1 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontSize: { xs: 18, md: 16, lg: 15, xl: 16 },
                              fontWeight: 600,
                              color: '#374151',
                            }}
                          >
                            Form 990-T
                          </Typography>

                          <Typography
                            variant="body2"
                            sx={{ color: '#637381', fontSize: 13 }}
                          >
                            These Forms will be auto-generated while you file
                            your 990-T form with us.{' '}
                          </Typography>
                        </Box>
                        <IconButton
                          sx={{
                            alignSelf: 'center',
                            p: 0.5,
                          }}
                        >
                          <ArrowForwardIosOutlinedIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </Stack>
                    </Link>
                  </Paper>
                  <Grid
                    container
                    spacing={2}
                    m={0}
                    sx={{
                      pt: '0 !important',
                      '& a': {
                        pl: '10px !important',
                        borderColor: '#dedede',
                        borderRadius: 2,
                      },
                      '& a:hover': {
                        color: '#c02652 !important',
                        backgroundColor: '#dedfe1',
                        borderColor: '#637381',
                      },
                    }}
                  >
                    <Grid
                      size={{ xs: 12, sm: 6 }}
                      sx={{
                        pt: '8px !important',
                      }}
                    >
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-990-t-schedule-a/`}
                        // className={getSubMenuActiveClassName(
                        //   '/information-returns/efile-irs-form-w2'
                        // )}
                      >
                        990-T Schedule A
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/schedule-d-form-1120-guide/`}
                        // className={getSubMenuActiveClassName(
                        //   '/information-returns/efile-irs-form-w2'
                        // )}
                      >
                        1120 Schedule D
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/schedule-d-form-1041-resource-guide/`}
                        // className={getSubMenuActiveClassName(
                        //   '/information-returns/efile-irs-form-w2'
                        // )}
                      >
                        1041 Schedule D
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/1041-schedule-i-amt/`}
                        // className={getSubMenuActiveClassName(
                        //   '/information-returns/efile-irs-form-w2'
                        // )}
                      >
                        1041 Schedule I
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-4797-sales-business-property/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Form 4797
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-4562-depreciation-amortization-guide/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Form 4562
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-8949-sales-and-dispositions-guide/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Form 8949
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-8995-qualified-business-income-deduction/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Form 8995
                      </Button>
                    </Grid>
                    <Grid
                      size={{ xs: 12, sm: 6 }}
                      sx={{
                        pt: '8px !important',
                      }}
                    >
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-2220-underpayment-estimated-tax-corporations/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Form 2220
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-3800-business-credits/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Form 3800
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-3468-investment-credit/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Form 3468
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-8911-alternative-fuel-credits/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Form 8911
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-8936-clean-vehicle-credit/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Form 8936
                        <Box
                          sx={
                            {
                              // position: 'absolute',
                              // right: 8.5,
                              // top: 7,
                              // maxHeight: 18,
                            }
                          }
                        >
                          <Box
                            component="span"
                            sx={{
                              display: 'inline-block',
                              // borderRadius: 50,
                              fontSize: { md: 11, lg: 12, xl: 13 },
                              fontWeight: 500,
                              color: '#c02652',
                              px: 0,
                              pt: 0.5,
                              ml: 0,
                              fontFamily: 'Roboto Condensed',
                              lineHeight: 1.2,
                            }}
                            // className="support-forms-noani"
                          >
                            Supports Schedule A
                          </Box>
                        </Box>
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-8050-instructions/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Form 8050
                        <Box
                          sx={
                            {
                              // position: 'absolute',
                              // right: 8.5,
                              // top: 7,
                              // maxHeight: 18,
                            }
                          }
                        >
                          {/* <Box
                            component="span"
                            sx={{
                              display: 'inline-block',
                              
                              fontSize: { md: 11, lg: 12, xl: 13 },
                              fontWeight: 500,
                              color: '#c02652',
                              px: 0,
                              pt: 0.5,
                              ml: 0,
                              fontFamily: 'Roboto Condensed',
                              lineHeight: 1.2,
                            }}
                            
                          >
                            Supports Schedule A
                          </Box> */}
                        </Box>
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href={`${resourcesRouteStartUrl}tax-exempt/form-3800-schedule-a/`}
                        // className={getSubMenuActiveClassName(
                        //   '/tax-exempt/form-990-schedule-b'
                        // )}
                      >
                        Schedule A (3800)
                        <Box
                          sx={
                            {
                              // position: 'absolute',
                              // right: 8.5,
                              // top: 7,
                              // maxHeight: 18,
                            }
                          }
                        >
                          {/* <Box
                            component="span"
                            sx={{
                              display: 'inline-block',
                              
                              fontSize: { md: 11, lg: 12, xl: 13 },
                              fontWeight: 500,
                              color: '#c02652',
                              px: 0,
                              pt: 0.5,
                              ml: 0,
                              fontFamily: 'Roboto Condensed',
                              lineHeight: 1.2,
                            }}
                            
                          >
                            Supports Schedule A
                          </Box> */}
                        </Box>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
        <Box
          className={getSubMenuHoverClassName('btn-exempt-instructions')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-exempt-instructions"
            onClick={() => toggleSelectedSubMenu('btn-exempt-instructions')}
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
            className={`${getActiveClassName(['/nonprofit-taxes'])}`}
          >
            State Filing
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: { sm: 720, md: 800 },
              right: 'auto !important',
              left: { md: '-680px !important', sm: '-625px !important' },
              '&:before': { left: { md: 718, sm: 658 } },
            }}
          >
            <Box sx={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }}>
              <Grid
                container
                spacing={2}
                m={0}
                className="MuiGrid-root-width"
                sx={{ justifyContent: 'center', px: 2 }}
              >
                <Grid size={12} sx={{ pt: '0 !important' }}>
                  <Paper
                    variant="outlined"
                    sx={{
                      border: '0px solid #dedede',
                      borderRadius: 2,
                      alignItems: 'center',
                      mb: 0,
                      '& a': {
                        pl: '8px !important',
                        borderColor: '#dedede',
                        borderRadius: 2,
                      },
                      '& a:hover': {
                        color: '#c02652 !important',
                        backgroundColor: '#dedfe1',
                        borderColor: '#637381',
                      },
                      '& a button': { transition: 'all 0.3s ease' },
                      '& a:hover button': { transform: 'translateX(5px)' },
                      '& > a': {
                        p: '10px !important',
                        mr: 0,
                        mb: { lg: 0, xl: 0 },
                        border: '1px solid #dedede',
                        borderRadius: 3,
                        minHeight: { lg: 65, xl: 68 },
                      },
                      '& > a:hover': {
                        color: '#213e99 !important',
                        backgroundColor: '#dedfe1',
                        borderColor: '#637381',
                      },
                      '& > a:hover h6': {
                        color: '#c02652 !important',
                      },
                      '& > a:hover .form-icon': { backgroundColor: '#fff' },
                    }}
                  >
                    <Link
                      href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}nonprofit-taxes/`}
                      sx={{}}
                    >
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={1}
                        sx={{
                          mr: 0,
                          justifyContent: 'flex-start',
                          alignItems: 'flex-start',
                        }}
                      >
                        <Box sx={{ flexGrow: 1 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontSize: { xs: 18, md: 16, lg: 15, xl: 16 },
                              fontWeight: 600,
                              color: '#374151',
                            }}
                          >
                            Non-Profit State Filing
                          </Typography>

                          <Typography
                            variant="body2"
                            sx={{ color: '#637381', fontSize: 13 }}
                          >
                            Streamline your state filings with clear, reliable
                            guidance.
                          </Typography>
                        </Box>
                        <IconButton
                          sx={{
                            alignSelf: 'center',
                            p: 0.5,
                          }}
                        >
                          <ArrowForwardIosOutlinedIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </Stack>
                    </Link>
                  </Paper>
                  <Grid
                    container
                    spacing={2}
                    sx={{
                      mt: '-16px !important',
                      '& a': {
                        pl: '8px !important',
                        borderColor: '#dedede',
                        borderRadius: 2,
                        fontSize: '12px !important',
                      },
                      '& a:hover': {
                        color: '#c02652 !important',
                        backgroundColor: '#dedfe1',
                        borderColor: '#637381',
                      },
                    }}
                  >
                    <Grid
                      size={{ xs: 12, sm: 3 }}
                      sx={{ pt: '8px !important' }}
                    >
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/alabama-state-filing-requirements/"
                      >
                        Alabama (AL)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/alaska-state-filing-requirements/"
                      >
                        Alaska (AK)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/arizona-state-filing-requirements/"
                      >
                        Arizona (AZ)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/arkansas-state-filing-requirements/"
                      >
                        Arkansas (AR)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/california-ftb-state-filing-requirements/"
                      >
                        California (CA)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/colorado-state-filing-requirements/"
                      >
                        Colorado (CO)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/connecticut-state-filing-requirements/"
                      >
                        Connecticut (CT)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/delaware-state-filing-requirements/"
                      >
                        Delaware (DE)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/district-of-columbia-state-filing-requirements/"
                      >
                        District of Columbia (DC)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/florida-state-filing-requirements/"
                      >
                        Flordia (FL)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/georgia-state-filing-requirements/"
                      >
                        Georgia (GA)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/hawaii-state-filing-requirements/"
                      >
                        Hawaii (HI)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/idaho-state-filing-requirements/"
                      >
                        Idaho (ID)
                      </Button>
                    </Grid>
                    <Grid
                      size={{ xs: 12, sm: 3 }}
                      sx={{ pt: '8px !important' }}
                    >
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/illinois-state-filing-requirements/"
                      >
                        Illinois (IL)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/indiana-state-filing-requirements/"
                      >
                        Indiana (IN)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/iowa-state-filing-requirements/"
                      >
                        Iowa (IA)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/kansas-state-filing-requirements/"
                      >
                        Kansas (KS)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/kentucky-state-filing-requirements/"
                      >
                        Kentucky (KY)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/louisiana-state-filing-requirements/"
                      >
                        Louisiana (LA)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/maine-state-filing-requirements/"
                      >
                        Maine (ME)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/maryland-state-filing-requirements/"
                      >
                        Maryland (MD)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/massachusetts-state-filing-requirements/"
                      >
                        Massachusetts (MA)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/michigan-state-filing-requirements/"
                      >
                        Michigan (MI)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/minnesota-state-filing-requirements/"
                      >
                        {' '}
                        Minnesota (MN)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/mississippi-state-filing-requirements/"
                      >
                        {' '}
                        Mississippi (MS)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/missouri-state-filing-requirements/"
                      >
                        {' '}
                        Missouri (MO)
                      </Button>
                    </Grid>
                    <Grid
                      size={{ xs: 12, sm: 3 }}
                      sx={{ pt: '8px !important' }}
                    >
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/montana-state-filing-requirements/"
                      >
                        {' '}
                        Montana (MT)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/nebraska-state-filing-requirements/"
                      >
                        {' '}
                        Nebraska (NE)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/nevada-state-filing-requirements/"
                      >
                        {' '}
                        Nevada (NV)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/new-hampshire-state-filing-requirements/"
                      >
                        {' '}
                        New Hampshire (NH)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/new-jersey-state-filing-requirements/"
                      >
                        {' '}
                        New Jersey (NJ)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/new-mexico-state-filing-requirements/"
                      >
                        {' '}
                        New Mexico (NM)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/new-york-state-filing-requirements/"
                      >
                        {' '}
                        New York (NY)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/north-carolina-state-filing-requirements/"
                      >
                        {' '}
                        North Carolina (NC)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/north-dakota-state-filing-requirements/"
                      >
                        {' '}
                        North Dakota (ND)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/ohio-state-filing-requirements/"
                      >
                        {' '}
                        Ohio (OH)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/oklahoma-state-filing-requirements/"
                      >
                        {' '}
                        Oklahoma (OK)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/oregon-state-filing-requirements/"
                      >
                        {' '}
                        Oregon (OR)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/pennsylvania-state-filing-requirements/"
                      >
                        {' '}
                        Pennsylvania (PA)
                      </Button>
                    </Grid>
                    <Grid
                      size={{ xs: 12, sm: 3 }}
                      sx={{ pt: '8px !important' }}
                    >
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/rhode-island-state-filing-requirements/"
                      >
                        Rhode Island (RI)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/south-carolina-state-filing-requirements/"
                      >
                        {' '}
                        South Carolina (SC)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/south-dakota-state-filing-requirements/"
                      >
                        {' '}
                        South Dakota (SD)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/tennessee-state-filing-requirements/"
                      >
                        {' '}
                        Tennessee (TN)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/texas-state-filing-requirements/"
                      >
                        {' '}
                        Texas (TX)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/utah-state-filing-requirements/"
                      >
                        {' '}
                        Utah (UT)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/vermont-state-filing-requirements/"
                      >
                        {' '}
                        Vermont (VT)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/virginia-state-filing-requirements/"
                      >
                        {' '}
                        Virginia (VA)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/washington-state-filing-requirements/"
                      >
                        {' '}
                        Washington (WA)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/west-virginia-state-filing-requirements/"
                      >
                        {' '}
                        West Virginia (WV)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/wisconsin-state-filing-requirements/"
                      >
                        {' '}
                        Wisconsin (WI)
                      </Button>
                      <Button
                        color="secondary"
                        variant="outlined"
                        size="small"
                        sx={{ textTransform: 'none', borderRadius: 1.5, mb: 1 }}
                        href="/nonprofit-taxes/wyoming-state-filing-requirements/"
                      >
                        {' '}
                        Wyoming (WY)
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ExemptSubMenu;
